var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":require('@/assets/images/png/logo.png'),"alt":"Gillette Logo"}}),_c('p',[_vm._v(" So viele Einlösungen sind noch verfügbar: ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.computedParticipations)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }